export const FLAG_GETTING_LEGAL_CARGOS = 'FLAG_GETTING_LEGAL_CARGOS';
export const GET_LEGAL_CARGOS = 'GET_LEGAL_CARGOS';
export const CLEAR_LEGAL_CARGOS = 'CLEAR_LEGAL_CARGOS';
export const FLAG_LEGAL_CARGO_ACTIVITY = 'FLAG_LEGAL_CARGO_ACTIVITY';
export const GET_LEGAL_CARGO = 'GET_LEGAL_CARGO';
export const CLEAR_LEGAL_CARGO = 'CLEAR_LEGAL_CARGO';
